import './StatisticsCard.css';
import React from 'react';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-react';
const StatisticsCard = props => {
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const isDetSite = props.isDetSite;
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    isDetSite: isDetSite
  }, /*#__PURE__*/React.createElement("article", {
    className: "statistics-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: `statistics-card__header-wrapper ${props.compactHeader ? "statistics-card__header-wrapper--compact" : ""}`
  }, /*#__PURE__*/React.createElement(Text, {
    className: "statistics-card__value",
    tag: "div",
    field: props.value
  })), /*#__PURE__*/React.createElement(RichText, {
    tag: "div",
    className: "statistics-card__description",
    field: props.description
  })));
};
export default StatisticsCard;
const StyledWrapper = _ref => {
  let {
    children,
    rtl,
    isDetSite
  } = _ref;
  const commonStyles = isDetSite ? "crgwk8l" : "c1b8d7yu";
  const ltrStyles = isDetSite ? "l4lwhyt" : "l1rv6l1k";
  const rtlStyles = isDetSite ? "riv53c8" : "r1z22rl";
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};